<template>
	<div>
		<q-toolbar class="bg-white q-px-sm q-px-md-lg">
			<q-img v-if="!neutral" src="/typo3conf/ext/ig_warehouse/Resources/Public/Images/schorn-groh-furniere-veneers.svg" class="logo" basic/>

			<q-space/>

			<q-tabs v-if="user" class="text-black" align="right" active-color="primary" dense shrink>
				<q-route-tab :to="{ name: 'products' }" :label="$t('products')" class="nav-tab q-px-sm" :class="isVeneerSearch"/>
				<q-route-tab :to="{ name: 'watchlists' }" :label="$t('watchlists')" class="nav-tab q-px-sm"/>
			</q-tabs>

			<template v-if="user">
				<q-avatar id="top-avatar" class="q-ml-sm" color="primary" text-color="white" size="2.5rem" font-size="1rem">{{ avatar }}</q-avatar>
				<q-menu target="#top-avatar">
					<q-list>
						<q-item clickable>
							<q-item-section>
								<language-switcher/>
							</q-item-section>
						</q-item>
						<q-item clickable>
							<q-item-section>
								<zoho-authentication/>
							</q-item-section>
						</q-item>
						<q-item clickable>
							<q-item-section>
								<a href="?logintype=logout">{{ $t('button.logout') }}</a>
							</q-item-section>
						</q-item>
					</q-list>
				</q-menu>
			</template>
			<template v-else>
				<language-switcher simple/>
			</template>
		</q-toolbar>
	</div>
</template>

<script>
	import ZohoAuthentication from "@/components/zoho/ZohoAuthentication";
	import NavigationMixin from "@/mixins/NavigationMixin";
	import LanguageSwitcher from "@/components/main/LanguageSwitcher";

	export default {
		name: "Navigation",
		components: {LanguageSwitcher, ZohoAuthentication},
		mixins: [NavigationMixin]
	}
</script>

<style lang="scss" scoped>
	.logo {
		max-width: 48px;
	}

	.q-tab.nav-tab {
		min-height: 49px;
	}

	#top-avatar {
		cursor: pointer;
	}

	@media(min-width: 600px) {
		.logo {
			max-width: 64px;
		}

		.q-tab.nav-tab {
			min-height: 63px;
		}
	}
</style>